import AuthRepository from "../data/auth.repository";
import SportRepository from "../data/sport.repository";
import PackageRepository from "../data/package.repository";
import CategoryRepository from "../data/category.repository";
import PickRepository from "../data/pick.repository";
import OddsRepository from "../data/odds.repository";
import ProductRepository from "../data/product.repository";
import * as types from "./mutation-types";

export default {
  login(context, data) {
    return new Promise((resolve, reject) => {
      AuthRepository.login(data.email, data.password)
        .then((response) => {
          localStorage.setItem("sts_token", response.token);
          context.commit(types.SET_USER, response.user);
          resolve(response.user);
        })
        .catch((e) => {
          reject(e);
        });
    });
  },
  logout(context, data) {
    localStorage.removeItem("sts_token");
    context.commit(types.SET_USER);
  },
  getStoredUser(context, data) {
    let token;
    try {
      token = localStorage.getItem("sts_token");
    } catch (err) {}
    if (!token) {
      return context.commit(types.SET_USER, null);
    } else {
      return AuthRepository.get(token)
        .then((user) => {
          return context.commit(types.SET_USER, user);
        })
        .catch(() => {
          localStorage.removeItem("sts_token");
          return context.commit(types.SET_USER, null);
        });
    }
  },
  getSports(context, data) {
    SportRepository.get().then((sports) => {
      context.commit(types.SET_SPORTS, sports);
    });
  },
  getPackages(context, data) {
    PackageRepository.get().then((ps) => {
      context.commit(types.SET_PACKAGES, ps);
    });
  },
  getCategories(context, data) {
    CategoryRepository.get().then((cats) => {
      context.commit(types.SET_CATS, cats);
    });
  },
  getFreePicks(context, data) {
    PickRepository.getFreePicks().then((picks) => {
      context.commit(types.SET_PICKS, picks);
    });
  },
  getUpcoming(context, sport) {
    return OddsRepository.getUpcoming(sport).then((odds) => {
      if (!odds) return;
      return context.commit(types.SET_ODDS, {
        sport: sport,
        data: {
          upcoming: {
            data: odds,
          },
        },
      });
    });
  },
  getLive(context, sport) {
    return OddsRepository.getLive(sport).then((odds) => {
      if (!odds) return;
      return context.commit(types.SET_ODDS, {
        sport: sport,
        data: {
          live: {
            data: odds,
          },
        },
      });
    });
  },
  setCurrentPackage(context, p) {
    context.commit(types.SET_CURRENT_PACKAGE, p);
  },
  // Shop actions
  getProducts(context) {
    return ProductRepository.getAll().then((products) => {
      context.commit(types.SET_PRODUCTS, products);
      return products;
    });
  },
  getProductBySlug(context, slug) {
    return ProductRepository.getBySlug(slug).then((product) => {
      context.commit(types.SET_CURRENT_PRODUCT, product);
      return product;
    });
  },
  addToCart(context, item) {
    context.commit(types.ADD_TO_CART, item);
  },
  updateCartItem(context, payload) {
    context.commit(types.UPDATE_CART_ITEM, payload);
  },
  removeFromCart(context, variantId) {
    context.commit(types.REMOVE_FROM_CART, variantId);
  },
  clearCart(context) {
    context.commit(types.CLEAR_CART);
  },
};



// WEBPACK FOOTER //
// ./src/store/actions.js